import { useState } from "react";
import { Tabs } from "../../../../components/Tabs";
import { GeneralSettings } from "./GeneralSettings";
import { TextSettings } from "./TextSettings";

const tabs = [
  {
    label: "General Settings",
  },
  {
    label: "Text Settings",
  }
]

export const PaymentGatewaySettings = () => {
  const [state, setState] = useState<string>("");
  const [zip, setZip] = useState<string>("");
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const hanbleTabChange = (index: number) => {
    setActiveIndex(index);
  }

  return (
    <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
      <div className="w-full bg-white p-4 rounded-md">
        <div className="w-full mt-2">
          <Tabs tabs={tabs} onChange={(index) => hanbleTabChange(index)} activeIndex={activeIndex} />
        </div>

        <div>
          {
            activeIndex === 0 && (
              <GeneralSettings
                state={state}
                setState={(value) => setState(value)}
                zip={zip}
                setZip={(value) => setZip(value)} />
            )
          }
          {
            activeIndex === 1 && (
              <TextSettings
                state={state}
                setState={(value) => setState(value)}
                zip={zip}
                setZip={(value) => setZip(value)} />
            )
          }
        </div>
      </div>
    </div>
  )
}